export enum TemplateBuilderConditionOperator {
  exists = 'exists',
  equals = 'equals',
  notEquals = 'notEquals',
  isTrue = 'isTrue',
  isFalse = 'isFalse',
}

export enum TemplateBuilderConditionMode {
  all = 'all',
  any = 'any',
}

export class TemplateBuilderConditionRule {
  field: string = '';
  operator: TemplateBuilderConditionOperator = TemplateBuilderConditionOperator.exists;
  value?: string | number | boolean = '';
}

export class TemplateBuilderConditions {
  mode: TemplateBuilderConditionMode = TemplateBuilderConditionMode.all;
  rules: TemplateBuilderConditionRule[] = [new TemplateBuilderConditionRule()];
}
